import useSWR from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import { invalidApiDataError } from "../../../../errors/recognisedErrors"
import { getClientProtected } from "../../clients/clients"
import { dnoThresholdMapper } from "../../mappers/dnoThreshold/dnoThresholdMapper"
import { ILicenceAreaThresholdsResponse } from "../../types/dnoThreshold/dnoThresholdTypes"
import { DNO_THRESHOLD_LICENCE_AREA_THRESHOLDS } from "../../urls/private"

interface IUseGetLicenceAreaThresholds {
    data: ILicenceAreaThresholdsResponse | undefined
    error: AppError | null
    isLoading: boolean
}

/**
 * SWR hook to fetch licence area thresholds for the current DNO
 * @returns Licence area thresholds data, error state, and loading state
 */
const useGetLicenceAreaThresholds = (): IUseGetLicenceAreaThresholds => {
    const { data, error, isLoading } = useSWR(
        DNO_THRESHOLD_LICENCE_AREA_THRESHOLDS,
        async (url: string): Promise<ILicenceAreaThresholdsResponse> => {
            try {
                const res = await getClientProtected(url)
                return dnoThresholdMapper.mapLicenceAreaThresholds(res)
            } catch (err) {
                const appError = parseAndThrowAppError(err)
                throw invalidApiDataError(appError.message)
            }
        }
    )
    return { data, error, isLoading }
}

export default useGetLicenceAreaThresholds
